"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

var _Element = require("./Element");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Slobodan Djordjevic, slobasd23
 */

/**
 * A base component to display icons from the trace font
 *
 * @component
 * @category Atoms
 */
var Icon = function Icon(_ref) {
  var type = _ref.type,
      size = _ref.size,
      color = _ref.color,
      noMargin = _ref.noMargin,
      onClick = _ref.onClick;
  var cn = "icon-".concat(type);

  if (onClick) {
    cn += ' clickable';
  }

  var styles = {};

  if (size) {
    styles['fontSize'] = "".concat(size, "px");
  }

  if (color) {
    if (color[0] === '#') {
      styles['color'] = color;
    } else {
      cn += ' text-' + color;
    }
  }

  if (noMargin) {
    styles['margin'] = '0';
  }

  return /*#__PURE__*/_react.default.createElement(_Element.Element, {
    onClick: onClick,
    tag: "i",
    style: styles,
    className: cn
  });
};
/**
 * Icon.Type
 * all the icons used by paneka design system
 *
 * @readonly
 * @enum {string}
 * @category Atoms
 */


exports.Icon = Icon;
Icon.Type = {
  /** no icon */
  None: '',

  /** the trace logo with square and text */
  Trace: 'trace',

  /** the trace logo with just the square */
  TraceSquare: 'trace_square',

  /** aka share */
  Action: 'action',

  /** aka share for larger icon size*/
  ActionLG: 'sharing_lg',
  Add: 'add',
  Bookmark: 'bookmark',
  CheveronDown: 'cheveron_down',
  CheveronLeft: 'cheveron_left',
  CheveronRight: 'cheveron_right',
  CheveronUp: 'cheveron_up',
  CheveronUpDown: 'cheveron_up_down',
  Download: 'download',
  Copy: 'copy',
  Edit: 'edit-1',
  Email: 'email',
  Field: 'field',
  Hide: 'hide',
  Info: 'information',
  Leave: 'leave',
  Link: 'link',
  Lock: 'lock',
  More: 'more',
  Help: 'question',
  Settings: 'settings',
  SignIn: 'sign_in',
  SignOut: 'signout',
  Soccer: 'soccer',
  Spotlight: 'spotlight',
  TraceId: 'trace-id',
  TraceIdLG: 'trace_id_lg',
  Unlock: 'unlock',
  View: 'view',
  Warning: 'warning',
  Check: 'checkmark',
  Close: 'close',
  Filter: 'filter',
  Menu: 'menu',
  Search: 'search',
  ArrowLeft: 'arrow_left',
  ArrowRight: 'arrow_right',
  ArrowUp: 'arrow_up',
  ArrowDown: 'arrow_down',
  Play: 'play',
  Pause: 'pause',
  Switch: 'switch',
  Profile: 'profile',
  Mobile: 'mobile',
  ZoomIn: 'zoom_in',
  ZoomOut: 'zoom_out',
  SDCard: 'sdcard',
  QRCode: 'qr_code',
  Trash: 'trash',
  Question: 'question',
  Wifi: 'wifi',
  Sun: 'sun',
  SoundMute: 'sound_mute',
  SoundOn: 'sound_on',
  JumpForward30: 'jump_fwd_30',
  JumpForward2: 'jump_fwd_2',
  JumpBack2: 'jump_back_2',
  JumpBack30: 'jump_back_30',
  LengthAdd2: 'lengthen_2',
  LengthRemove2: 'shorten_2',
  JumpAhead5: 'jump_fwd_5',
  JumpBack5: 'jump_back_5',
  Next: 'next',
  PlayersSoccer: 'players_soccer',
  Playlist: 'playlist',
  Twitter: 'twitter',
  Facebook: 'facebook',
  Instagram: 'instagram',
  Games: 'games',
  Moment: 'moment',
  Create: 'create',
  Tag: 'tag',
  Expand: 'expand',
  Collapse: 'collapse',
  Upgrade: 'upgrade',
  TraceIDFilled: 'trace-id-filled',
  TraceIDEmpty: 'trace-id-empty',
  Stats: 'stats',
  Forward2: 'jump_fwd_2',
  Back2: 'jump_back_2',
  Cut2Seconds: 'cut-2-seconds',
  Add2Seconds: 'add-2-seconds',
  Underline: 'underline',
  UnorderedList: 'unordered-list',
  OrderedList: 'ordered-list',
  Bold: 'bold',
  Italics: 'italics',
  JumpFwd05: 'jump_fwd_halfsec',
  JumpBack05: 'jump_back_halfsec',
  JumpFwd10: 'jump_fwd_10',
  JumpBack10: 'jump_back_10',
  Leaderboard: 'leaderboard',
  Referral: 'referral',
  Academy: 'academy',
  HeartOutline: 'trace-id-heart-outline',
  HeartFilled: 'trace-id-heart-filled',
  PlayersGeneric: 'players_generic',
  Film: 'film-1',
  Multicam: 'Multicam',
  AutoSwitch: 'auto_switch',
  PlayersBaseball: 'players_bsball',
  Baseball: 'bsball',
  Bell: 'bell',
  BellUnread: 'bell-unread'
};
Icon.propTypes = {
  /* The icon to display, one of Icon.Type */
  type: _propTypes.default.oneOf(Object.keys(Icon.Type).map(function (key) {
    return Icon.Type[key];
  })),

  /* Font size of the icon */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /* Color of the icon */
  color: _propTypes.default.string,

  /* Will remove margin from around the icon */
  noMargin: _propTypes.default.bool,

  /* click handler */
  onClick: _propTypes.default.func
};